<template>
  <v-app>
    <div class="header-container" style="background: rgb(74, 147, 174);">
      <div class="banner-container">
        <img :src="require('./assets/urgencias.png')" class="banner-img">
      </div>
    </div>
    <v-content transition="slide-x-transition">
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      //
    };
  }
};
</script>
<style>
.header-container {
  width: 100%;
  height: auto;
  z-index: 20;
}

.banner-img {
  width: 1031px;
  height: 175px;
  display: block;
  margin: 0 auto;
}

@media only screen and (max-width: 980px) {
  .banner-img {
    width: 100% !important;
    height: auto;
  }
}
</style>
